import * as React from "react";
import { cn } from "@/lib/utils";

/** Variant is retained as a prop for back-compat; the accent now comes from
 *  the nearest [data-section] ancestor via the --accent CSS variables. */
export type NeonVariant = "cyan" | "purple" | "default";

type NeonCardOwnProps = {
  variant?: NeonVariant;
  as?: React.ElementType;
  interactive?: boolean;
  className?: string;
  children?: React.ReactNode;
};

export type NeonCardProps = NeonCardOwnProps & {
  [key: string]: unknown;
};

export const NeonCard = React.forwardRef<HTMLElement, NeonCardProps>(
  function NeonCard(props, ref) {
    const {
      as,
      variant: _variant,
      interactive = false,
      className,
      children,
      ...rest
    } = props as NeonCardOwnProps & Record<string, unknown>;
    void _variant;
    const Component = (as ?? "div") as React.ElementType;
    return (
      <Component
        ref={ref}
        className={cn(
          "glass-card",
          interactive &&
            "cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)]",
          className,
        )}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);
